module.exports = __webpack_public_path__ + "img/info.102fc949.svg";